export default "__VITE_ASSET__X6X5sPr9__"